import { ValidationStatus } from '../../../../../../../views/marketing/followers/import';

export default {
  status: {
    [ValidationStatus.Valid]: {
      title: 'Je import is bijna klaar!',
      description: 'Klik op de knop Doorgaan om de import te voltooien',
    },
    [ValidationStatus.HasInvalidContent]: {
      title: 'Sommige gegevens in uw bestand ontbreken of hebben een onjuist formaat',
      description:
        'Los de onderstaande fouten op en upload het bestand opnieuw, of ga door om ongeldige rijen/cellen te negeren',
    },
    [ValidationStatus.Invalid]: {
      title: 'Geüpload bestand kan niet worden verwerkt',
      description: 'Los de onderstaande fouten op en probeer het opnieuw',
    },
  },
  sections: {
    heading_validation: {
      title: 'Kolomnamen/-volgorde komen niet overeen:',
      rules: {
        Exact: 'Kolom #{{column}} moet aanwezig zijn en exact <strong>{{expected}}</strong> heten',
      },
    },
    content_validation: {
      title: 'Volgende fouten gedetecteerd:',
      labels: {
        row: 'Rij <strong>#{{row}}:</strong>',
        imported_rows_one: '{{count}} rij wordt geïmporteerd',
        imported_rows_other: '{{count}} rijen worden geïmporteerd',
        ignored_rows_one: '{{count}} rij wordt genegeerd',
        ignored_rows_other: '{{count}} rijen worden genegeerd',
      },
      fields: {
        email: 'E-mail',
        phone_number: 'Telefoonnummer',
        first_name: 'Voornaam',
        last_name: 'Achternaam',
        birthday: 'Verjaardag',
      },
      rules: {
        Required: 'Veld {{field}} is verplicht. Rij wordt genegeerd',
        Email: 'Veld {{field}} dient een geldig e-mailadres te zijn. Rij wordt genegeerd',
        Phone: 'Veld {{field}} dient een telefoonnummer in internationaal formaat te zijn. Veld wordt genegeerd',
        Date: 'Veld {{field}} dient een geldige datum te zijn. Veld wordt genegeerd',
      },
    },
  },
  buttons: {
    back_to_upload: 'Terug naar uploaden',
    proceed: 'Doorgaan',
  },
  toasts: {
    error: 'Er is iets misgegaan, neem contact op met support',
  },
};
